<p class="pt-3">
    <button
        title="Send Invoices"
        pButton
        pRipple
        severity="primary"
        icon="pi pi-send"
        type="button"
        (click)="SendInvoices.next(dataTable.selection)"
        [disabled]="!(dataTable.selection?.length > 0)"
        label="Send Invoices"
    ></button>
</p>
<div style="display: flex; flex-direction: column; height: 74vh">
    <div style="height: 65vh">
        <p-table stripedRows id="dataTable"
            #dataTable
            [value]="items"
            [(selection)]="selectedInvoices"
            sortField="Employeename"
            dataKey="id"
            editMode="row"
            [scrollable]="true"
            scrollHeight="flex"
        >
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" style="text-align: center">
                        <div class="tabulator-placeholder">
                            <span> No Data Available </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="loadingbody">
                <tr>
                    <td colspan="6" style="text-align: center">
                        <div>
                            Loading...<i class="fa fa-spinner fa-spin"></i>
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template #header let-item>
                <tr>
                    <!-- Status-->
                    <th class="status-cell">
                        <i
                            class="pi pi-exclamation-circle"
                            title="Status"
                        ></i>
                    </th>
                    <!-- Selection -->
                    <th class="select-cell">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <!-- Name -->
                    <th>
                        Name
                        <p-sortIcon
                            pSortableColumn="FullName"
                            field="FullName"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"
                        ></p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="FullName" display="menu" class="ml-auto" />
                    </th>
                    <!-- Invoice Start -->
                    <th>
                        Invoice Start
                        <p-sortIcon
                            pSortableColumn="InvoiceStart"
                            field="InvoiceStart"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"
                        ></p-sortIcon>
                    </th>
                    <!-- Invoice End -->
                    <th>
                        Invoice End
                        <p-sortIcon
                            pSortableColumn="InvoiceEnd"
                            field="InvoiceEnd"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"
                        ></p-sortIcon>
                    </th>
                    <!-- Invoice Total -->
                    <th>
                        Invoice Total
                        <p-sortIcon
                            pSortableColumn="InvoiceTotal"
                            field="InvoiceTotal"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"
                        ></p-sortIcon>
                    </th>
                    <!-- Invoice Nbr -->
                    <th>
                        Invoice Nbr
                        <p-sortIcon
                            pSortableColumn="InvoiceNbr"
                            field="InvoiceNbr"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"
                        ></p-sortIcon>
                    </th>
                    <!-- Sent to QB -->
                    <th>
                        QuickBooks Online
                        <p-sortIcon
                            pSortableColumn="InvoiceSentToQB"
                            field="InvoiceSentToQB"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"
                        ></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template
                #body
                let-item
                let-edit="editing"
                let-ri="rowIndex"
                let-rowData
            >
                <tr
                    data-id="row-{{ item?.id }}"
                    [pEditableRow]="item"
                >
                    <!-- Status-->
                    <td class="status-cell">
                        <div (click)="onStatusClick(item)" class="status-cell">
                            <ef-status-icon
                                [status]="item?.Status?.StatusCode"
                                [message]="item?.Status?.Message"
                            ></ef-status-icon>
                        </div>
                    </td>
                    <!-- Selection -->
                    <td class="select-cell">
                        <p-tableCheckbox [value]="item"></p-tableCheckbox>
                    </td>
                    <!-- Name -->
                    <td class="disabled">
                        {{ item?.FullName }}
                    </td>
                    <!-- Invoice Start-->
                    <td class="disabled">
                        <div
                            data-toggle="tooltip"
                            data-placement="top"
                            [attr.title]="item?.InvoiceStart"
                        >
                            {{
                                moment(item?.InvoiceStart).format('MM/DD/YYYY')
                            }}
                        </div>
                    </td>
                    <!-- Invoice End -->
                    <td class="disabled">
                        <div
                            data-toggle="tooltip"
                            data-placement="top"
                            [attr.title]="item?.InvoiceEnd"
                        >
                            {{ moment(item?.InvoiceEnd).format('MM/DD/YYYY') }}
                        </div>
                    </td>
                    <!-- Invoice Total -->
                    <td class="currency disabled">
                        <div
                            data-toggle="tooltip"
                            data-placement="top"
                            [attr.title]="item?.InvoiceTotal"
                        >
                            {{
                                item?.InvoiceTotal?.toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD'
                                })
                            }}
                        </div>
                    </td>
                    <!-- Invoice Nbr -->
                    <td class="disabled">
                        <div
                            data-toggle="tooltip"
                            data-placement="top"
                            [attr.title]="item?.InvoiceNbr"
                        >
                            {{ item?.InvoiceNbr }}
                        </div>
                    </td>
                    <!-- Sent to QBO -->
                    <td class="disabled">
                        <ef-checkbox
                            disabled="true"
                            [rowData]="item"
                            property="InvoiceSentToQB"
                        ></ef-checkbox>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
